import { ConfigService } from "@shuttlerock/configuration";
import fetch from "cross-fetch";
import { useUser } from "../internal/AuthClient";

export async function requestPasswordReset(email: string) {
  const data = {
    email,
    client_id: ConfigService.AUTH0_CLIENT_ID(),
    connection: ConfigService.AUTH0_DATABASE_CONNECTION_NAME(),
  };

  try {
    const result = await fetch(
      `https://${ConfigService.AUTH0_DOMAIN()}/dbconnections/change_password`,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    );

    const text = await result.text();

    if (result.status >= 400) {
      throw new Error(text);
    }

    return { body: result.body };
  } catch (error) {
    return { error };
  }
}

export const useRequestPasswordReset = () => {
  const user = useUser();

  return async () => {
    return requestPasswordReset(user?.email as string);
  };
};
